/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 9eddebd4 (Tue Feb 17 18:34:36 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  AgreementWebhookRequestBodyAgreementDeviceInfoLocation,
  AgreementWebhookRequestBodyAgreementDeviceInfoLocationFromJSON,
  AgreementWebhookRequestBodyAgreementDeviceInfoLocationToJSON,
} from './'

/**
 *
 * @export
 * @interface AgreementWebhookRequestBodyAgreementDeviceInfo
 */
export interface AgreementWebhookRequestBodyAgreementDeviceInfo {
  /**
   *
   * @type string
   * @memberof AgreementWebhookRequestBodyAgreementDeviceInfo
   */
  applicationDescription?: string
  /**
   *
   * @type string
   * @memberof AgreementWebhookRequestBodyAgreementDeviceInfo
   */
  deviceDescription?: string
  /**
   *
   * @type AgreementWebhookRequestBodyAgreementDeviceInfoLocation
   * @memberof AgreementWebhookRequestBodyAgreementDeviceInfo
   */
  location?: AgreementWebhookRequestBodyAgreementDeviceInfoLocation
  /**
   *
   * @type string
   * @memberof AgreementWebhookRequestBodyAgreementDeviceInfo
   */
  deviceTime?: string
}

export function AgreementWebhookRequestBodyAgreementDeviceInfoFromJSON(
  json: any
): AgreementWebhookRequestBodyAgreementDeviceInfo {
  return AgreementWebhookRequestBodyAgreementDeviceInfoFromJSONTyped(
    json,
    false
  )
}

export function AgreementWebhookRequestBodyAgreementDeviceInfoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AgreementWebhookRequestBodyAgreementDeviceInfo {
  if (json === undefined || json === null) {
    return json
  }
  return {
    applicationDescription: !exists(json, 'applicationDescription')
      ? undefined
      : json['applicationDescription'],
    deviceDescription: !exists(json, 'deviceDescription')
      ? undefined
      : json['deviceDescription'],
    location: !exists(json, 'location')
      ? undefined
      : AgreementWebhookRequestBodyAgreementDeviceInfoLocationFromJSON(
          json['location']
        ),
    deviceTime: !exists(json, 'deviceTime') ? undefined : json['deviceTime'],
  }
}

export function AgreementWebhookRequestBodyAgreementDeviceInfoToJSON(
  value?: AgreementWebhookRequestBodyAgreementDeviceInfo | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    applicationDescription: value.applicationDescription,
    deviceDescription: value.deviceDescription,
    location: AgreementWebhookRequestBodyAgreementDeviceInfoLocationToJSON(
      value.location
    ),
    deviceTime: value.deviceTime,
  }
}
